module.exports = __webpack_public_path__ + "static/GNT1-969ccaf2703c7c847b9397314a6dd709.png";